<template>
  <div class="d-flex flex-row nowrap text-primary-orange" style="gap: 6px">
    <div>
      <ErrorExclamationSvg :color="'var(--primary-orange)'" />
    </div>
    <div>
      <slot>{{ props.text }}</slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import ErrorExclamationSvg from '@/assets/ErrorExclamationSvg.vue'
  import { defineProps } from 'vue'
  interface Props {
    text?: string
  }
  const props = defineProps<Props>()
</script>

<style></style>
